import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import ChartSquareBarIcon from '../../components/icons/ChartSquareBar';

export interface MenuReports {
  id: number;
  title: string;
  path: string;
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
}

export interface MenuReportItem {
  id: number;
  title: string;
  minimo: number;
  medio: number;
  maximo: number;
}

const DataMenuCompraDeuda: MenuReports[] = [
  {
    id: 14,
    title: 'Reporte Compra Deuda',
    path: '/admin/compra-deuda',
    Icon: ChartSquareBarIcon,
  },
];

export default DataMenuCompraDeuda;
